export default {
  clone: 'Clonar',
  endate_camp: 'Fecha de fin',
  startdate_camp: 'Fecha de Inicio',
  clone_camp: 'Clonar Campaña',
  new_camp: 'Nombre de la nueva campaña',
  noresult: 'No se encontraron resultados.'
}
